import React, { useMemo, useState } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
dayjs.extend(customParseFormat);

export default function TicketTemplate1({ transaction, displayName }) {
  const [totalAmount, setTotalAmount] = useState(0);
  const bets = useMemo(() => {
    // First group by bettingOption and combination length
    const bets = {};
    for (const bet of transaction.bets) {
      const key = bet.combination;
      if (!bets[key]) {
        bets[key] = {
          ...bet,
          amount: 0,
          rambleAmount: 0,
        };
      }
      if (bet.bettingOption === 'target') {
        bets[key].amount += +bet.amount;
      } else if (bet.bettingOption === 'ramble') {
        bets[key].rambleAmount += +bet.amount;
      } else if (bet.bettingOption === 'S/O') {
        bets[key].amount = 0;
        bets[key].rambleAmount = 0;
      }
      setTotalAmount((prev) => +prev + +bet.amount);
    }

    return Object.values(bets);
  }, [transaction]);

  const drawId = dayjs(transaction.drawDate)
    .diff(dayjs('2025-04-12'), 'day')
    .toString()
    .padStart(7, '0');

  return (
    <div className='grid max-h-0 overflow-hidden'>
      <div
        id='print-ticket'
        className='w-[217px] text-[10px] flex flex-col gap-4 bg-white font-bitMatrix'
      >
        <div className='flex flex-col'>
          <div className='flex flex-col justify-between'>
            <div className='leading-tight'>
              <div>3D GAMES</div>
              <div>KD GAMING</div>
              <div>8.24</div>
              <div className='flex flex-col text-left'>
                <span>Cashier Code: {displayName}</span>
                <span>
                  Draw Date:{' '}
                  {dayjs(transaction.bets[0].createdAt).format(
                    'DD-MMM-YYYY HH:mm:ss'
                  )}
                </span>

                <span>
                  Draw Time: {dayjs(transaction.drawTime, 'HH:mm').format('hA')}{' '}
                  ({drawId})
                </span>
                <span>
                  Ref. No:
                  {dayjs(transaction.bets[0].createdAt).format('YYMMDD') +
                    new Date().getTime().toString()}
                </span>
                <div className='grid grid-cols-3 mt-3'>
                  <div>Combination</div>
                  <div className='text-center'>Target</div>
                  <div className='text-center'>Rambol</div>
                </div>
                {bets.map((bet, index) => (
                  <div key={index} className='grid grid-cols-3'>
                    <div>{bet.combination}</div>
                    <div className='text-center'>{bet.amount}</div>
                    <div className='text-center'>{bet.rambleAmount}</div>
                  </div>
                ))}
                <span>
                  Total Bets/Amount: {bets.length}/{totalAmount}
                </span>
                {/* <div className='flex flex-col items-baseline leading-tight'>
                  <span>
                    Ticket Price: ₱
                    {toCurrency(
                      betGroup
                        .filter((bet) => bet.bettingOption !== 'S/O')
                        .reduce((acc, bet) => +acc + +bet.amount, 0)
                    )}
                  </span>
                </div> */}
              </div>
            </div>
            {/* QR Code */}
            <div className='flex mt-2'>
              <QRCodeSVG
                value={transaction.id}
                width={90}
                height={90}
                level='H'
              />
            </div>
          </div>
        </div>
        <div className='h-4'></div>
      </div>
    </div>
  );
}
